export default __webpack_public_path__ + "static/linia-step-1-2764cb72f16239de22ef8a3f4e637e81.svg";